<template>
  <div>
     <div class="dropper mt-4">
     <input type="file"
            multiple="multiple"
            accept="image/*"
            @change="grabImages($event.target.files)" />
     <span>Drag files here!</span>
  </div>   
 </div>
</template>
 
<script>
    export default {
      name: 'Uploader',
      methods: {
        grabImages(images) {
          this.$emit('getUploadFiles', images)
        }
      }
    }
</script>

<style scoped>
    #uploader {
      -webkit-appearance: none;
      appearance: none;
      width: 50%;
      margin-bottom: 10px;
    }
    .dropper {
      height: 30vh;
      border: 2px dashed black;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }
    .dropper:hover {
      background-color: #eee;
      cursor: hand;
    }
    input {
      width: 100%;
      height: 30vh;
      position: absolute;
      opacity: 0;    
    }
</style>



// WEBPACK FOOTER //
// src/components/Helpers/Uploader.vue